import { isRecord } from 'shared/lib/guards';

/**
 * Достаёт строковый message для ErrorPayloadDto.
 * Нестроковые значения (в т.ч. объектный e.message) отбрасываем — иначе сломается контракт мониторинга.
 */
export const getMonitoringErrorMessage = (error: unknown): string => {
  if (typeof error === 'string') {
    return error;
  }

  if (!isRecord(error)) {
    return '';
  }

  const { message } = error;

  if (isRecord(message) && typeof message.error === 'string') {
    return message.error;
  }

  if (typeof message === 'string') {
    return message;
  }

  return '';
};
